import { SettingsCard } from "@/containers/game/settings/styled-components";
import { BybSlider } from "@Components/common/byb-ds";
import SettingsPage from "@Components/game/settings/settings-page";
import Section from "@Containers/shared/cards/section";
import { AnalyticsEvents, Preferences } from "@Enums/index";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useGameSettings from "@hooks/common/settings/use-game-settings";
import useI18n from "@i18n";
import { Stack } from "@mui/material";

const controllerDefaults = { [Preferences.haptic_strength]: 50 };

const ControllerSettings = () => {
  const { i18n } = useI18n();
  const { track } = useAnalytics();
  const { values, setValue, ready, error, refetch } = useGameSettings(controllerDefaults, {
    onApply: values => track(AnalyticsEvents.haptic_strength_adjusted, { hapticStrength: values[Preferences.haptic_strength] }),
  });

  return (
    <SettingsPage id="SETTINGS-CONTROLLER" title={i18n("settings.controller.title")} ready={ready} error={error} refetch={refetch}>
      <Section title={i18n("settings.controller.section")}>
        <Stack spacing={1.5}>
          <SettingsCard>
            <BybSlider
              label={i18n("settings.controller.haptic.strength")}
              value={values[Preferences.haptic_strength]}
              onChange={value => setValue(Preferences.haptic_strength, value)}
            />
          </SettingsCard>
        </Stack>
      </Section>
    </SettingsPage>
  );
};

export default ControllerSettings;
